<span *ngIf="state.isUnknown; else knownOrchestration"> Unknown orchestration </span>

<ng-template #knownOrchestration>
  <div
    *ngIf="state.orchestrationData"
    [matTooltip]="
      state.orchestrationData.isDeleted ? 'This orchestration was probably removed' : state.orchestrationData.path
    "
  >
    <fa-icon *ngIf="state.orchestrationData.isDeleted" class="fs-09 mr-2" [icon]="['fal', 'trash-alt']"></fa-icon>
    <span [attr.data-test]="'orchestration-name-' + state.orchestrationData.name || state.orchestrationData.path">{{
      state.orchestrationData.name || state.orchestrationData.path
    }}</span>
  </div>
</ng-template>
